'use client';

import { Gift } from '@shared/icons';
import { twMerge } from '@shared/themes';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { Link } from '../../Link/Link';
import type { FreeBetNotificationProps } from './types';
import { useFreeBetNotification } from './useFreeBetNotification';

type FreeBetNotificationComponentProps = FreeBetNotificationProps & {
  playerNr: string;
};

function FreeBetNotification({ playerNr, className }: FreeBetNotificationComponentProps) {
  const t = useTranslations('sportsbook.free_bet_notification');
  const { hasFreeBet, status, isLoading } = useFreeBetNotification({ playerNr });

  if (isLoading || !hasFreeBet || !status) {
    return null;
  }

  const isSleeping = status === 'Sleeping';
  const translationKey = isSleeping ? 'sleeping' : 'message';

  return (
    <div
      className={twMerge('flex w-full flex-row items-center justify-center gap-2 bg-success-background px-4 py-2 md:justify-center', className)}
      data-testid="free-bet-notification"
      role="status"
      aria-live="polite"
    >
      <Gift size="medium" className="text-success-foreground" data-testid="free-bet-notification-icon" />
      <p className="paragraph-explanatory-strong" data-testid="free-bet-notification-message">
        {t(translationKey)}
        {!isSleeping && (
          <>
            &nbsp;
            <Link href={`${ROUTES.SPORTS.HELP_GUIDE}#Freebet`} size="explanatory" target="_blank" rel="noopener noreferrer" data-testid="free-bet-notification-t-and-c-link">
              {t('view_t_and_c')}
            </Link>
          </>
        )}
      </p>
    </div>
  );
}

export { FreeBetNotification };
